document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('vat-toggle');

  if (!checkbox) return;

  checkbox.checked = localStorage.getItem('showIncVat') !== 'no';

  function getPrice(text) {
    const match = text.replace(/,/g, '').match(/[\d]+(\.\d{1,2})?/);
    return match ? parseFloat(match[0]) : null;
  }

  function updatePrices() {
    const showIncVat = checkbox.checked;

    document.querySelectorAll('.price-item').forEach(function (el) {
      if (!el.textContent.includes('£')) return;

      let incVatPrice = el.getAttribute('data-inc-vat-price');

      if (!incVatPrice) {
        incVatPrice = getPrice(el.textContent);
        if (!incVatPrice) return;
        el.setAttribute('data-inc-vat-price', incVatPrice);
      }

      incVatPrice = parseFloat(incVatPrice);

      const finalPrice = showIncVat
        ? incVatPrice
        : incVatPrice / 1.2;

      el.textContent = '£' + finalPrice.toFixed(2);
    });
  }

  checkbox.addEventListener('change', function () {
    localStorage.setItem('showIncVat', checkbox.checked ? 'yes' : 'no');
    updatePrices();
  });

  updatePrices();
});